import FKUStock from '@/models/item/fku/stock'
import SKUStock from '@/models/item/sku/stock'
import Stock from '@/models/item/stock'
import DisplayRule from '@/models/item/stock/specification/display-rule'
import StockIsFew from '@/models/item/stock/specification/stock-is-few'

/**
 * 調整在庫がONかつWEB在庫が特定値以下のときに「残りX点」表示をすることを判定するホテラバ用のルール。
 * src/Model/Item/Stock/Specification/DisplayRule/EachCase/HlWebStockIsSome.php と実装を合わせる。
 * @see https://github.com/my-color/front/issues/7207#issuecomment-1530840993
 */
export default class HlWebStockIsSome implements DisplayRule {

  constructor(private readonly spec: StockIsFew) {}

  shouldApply(stock: Stock): boolean {

    const targetStock = this.getTargetStock(stock)
    if (targetStock.display.isDisable) return false

    return this.spec.verify(targetStock.web)
  }

  apply(stock: Stock): string {
    return `残り${ this.getTargetStock(stock).web.amount }点`
  }

  /**
   * 引数がFKUStockの場合に、調整在庫がOFFのSKUStockを除外した(仮想的な)FKUStockを返す
   */
  private getTargetStock(stock: Stock): Stock {

    if (!(stock instanceof FKUStock)) return stock

    return stock.getFilteredFkuStock(
      (skuStock: SKUStock) => skuStock.display.isEnable
    )
  }
}
